module.exports = {
	"bidHistory": "Bid History",
	"number": "Number of lots :",
	"shareThis": "Share this lot",
	"status": {
		"cancelled": "Cancelled",
		"open": "Open",
		"sold": "Sold"
	},
	"underApproval": {
		"name": "Under Approval",
		"description": "This lot requires manual approval once sold."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/lot.json5
// module id = 1939
// module chunks = 6